module.exports = __webpack_public_path__ + "img/cover-game-02.8da129a9.jpg";